import React, { Component } from 'react'
import styled from "styled-components"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import ProductCard from "../ProductCard"
import ArrowIcon from "../../components/Icons/ArrowIcon"
import BreakpointUp from "../../components/Media/BreakpointUp"
import BreakpointDown from "../../components/Media/BreakpointDown"
import LeftArrowIcon from "../../components/Icons/LeftArrowIcon"

const SlickItem = styled.div`
  display:block !important;
  outline:none;
  max-width:100%;
  padding:10px 5px;
  @media(min-width:992px){
    padding:10px;    
  }
  
  & .card{
    position: relative;
    flex-direction: column-reverse;
    box-shadow: 0px 5px 15px rgba(0,0,0,0.2);
  }
  & .card-body{
    width:100%;
    ${BreakpointDown.sm`				
      padding:30px 15px;    
    `}    
  }
  & .card-img{
    width:100%;
    height: auto;
    ${BreakpointUp.lg`
      height: 322px;
    `}
  }
  & .measurement{
    display:none;
  }
`
const SlickCarousel = styled.div`  
  position:relative;
  padding-bottom:30px;
`
const SlickArrow = styled.div`  
  position:absolute;
  left:50%;
  transform:translateX(-50%);
  bottom:0;
  width:100px;
  display: flex;
  flex-wrap:wrap;
  justify-content: space-between;
  .slick-arrow{
    display:flex;
    align-items:center;
    justify-content:center;
    width: 40px;
    height: 40px;    
    border-radius: 50px;
    background: #fff;
    border: 1px solid #ddd;
    text-align: center;
    cursor: pointer;
    & svg {
      transition: all .3s ease;
      fill: #020304;
    }
    &:hover {
      border: 1px solid #020304;      
    }
  }

`
const LeftArrow = styled.div` 
  left:0;
  &:hover {
    & svg {
      transform: translateX(-5px);
    }
  }
`
const RightArrow = styled.div`
  right:0;
  &:hover {
    & svg {
      transform: translateX(5px);
    }
  }
`

function CircleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: "flex"}}
      onClick={onClick}
    ><ArrowIcon/></button>
  );
}

function CirclePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: "flex"}}
      onClick={onClick}
    ><ArrowIcon/></button>
  );
}

export default class RelatedProductCarousel extends Component {
  constructor(props) {
    super(props)
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }
  next() {
    this.slider.slickNext();
  }
  previous() {
    this.slider.slickPrev();
  }
  render() {
    const settings = {
      infinite: true,
      slidesToShow: 3,
      speed: 500,
      nextArrow: <CircleNextArrow />,
      prevArrow: <CirclePrevArrow />,
      arrow: false,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows:false,
            centerMode: true,
            centerPadding: '10px',            
            infinite: true

          }
        }
      ]     
    };
    const { data } = this.props
    return (    
      <SlickCarousel>     
        <Slider {...settings} ref={c => (this.slider = c)}>
          {
            data.edges.map((item, i) => {
              return(
                <SlickItem key={i}>
                  <ProductCard data={item.node} showQuote={this.props.showQuote}  />
                </SlickItem>
              )
            })
          }
         
        </Slider>
        <SlickArrow>
          <LeftArrow onClick={this.previous} className='slick-arrow'><LeftArrowIcon /></LeftArrow>
          <RightArrow onClick={this.next} className='slick-arrow'><ArrowIcon /></RightArrow>
        </SlickArrow>
      </SlickCarousel>
    );
  }
}
